import { render, staticRenderFns } from "./MatchSort.vue?vue&type=template&id=29990d59&scoped=true&"
import script from "./MatchSort.vue?vue&type=script&lang=js&"
export * from "./MatchSort.vue?vue&type=script&lang=js&"
import style0 from "./MatchSort.vue?vue&type=style&index=0&id=29990d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29990d59",
  null
  
)

export default component.exports